import { PASSWORD_MAX_LENGTH } from "./passwordPolicy";

export const preventPasswordPaste = (event) => {
  event.preventDefault();
};

export const confirmPasswordInputProps = {
  onPaste: preventPasswordPaste,
  onDrop: preventPasswordPaste,
  maxLength: PASSWORD_MAX_LENGTH,
};
